import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Logo } from '@/components/generals/logo'

const columns = [
    {
        title: 'Browse',
        links: [
            { href: '/tools', label: 'Full directory' },
            { href: '/free-tools', label: 'Free AI tools' },
            { href: '/open-source', label: 'Open source and local' },
            { href: '/use-cases', label: 'Tools by use case' }
        ]
    },
    {
        title: 'Compare',
        links: [
            { href: '/compare', label: 'Matchups and alternatives' },
            { href: '/shut-down', label: 'Shut down tracker' },
            { href: '/#categories', label: 'All categories' }
        ]
    }
]

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='mt-24 border-t border-border/70 bg-card/40'>
            <div className='mx-auto grid max-w-7xl gap-12 px-4 py-14 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr] lg:px-8'>
                <div className='max-w-sm'>
                    <Link href='/' aria-label='Framerank home' className='inline-flex rounded-lg focus-visible:outline-2 focus-visible:outline-primary'>
                        <Logo />
                    </Link>

                    <p className='mt-4 text-sm leading-relaxed text-muted-foreground'>
                        Independent rankings of AI video and image tools. Scores are editorial opinions, and plans and features change fast, so always check a tool&apos;s own site before you pay.
                    </p>
                </div>

                {columns.map(column => (
                    <div key={column.title}>
                        <h2 className='font-heading text-sm font-semibold uppercase tracking-[0.14em] text-foreground'>
                            {column.title}
                        </h2>

                        <ul className='mt-4 space-y-3'>
                            {column.links.map(link => (
                                <li key={link.href}>
                                    <Link
                                        href={link.href}
                                        className='text-sm text-muted-foreground transition-colors hover:text-foreground focus-visible:outline-2 focus-visible:outline-primary'
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <div className='border-t border-border/70'>
                <p className='mx-auto max-w-7xl px-4 py-6 text-xs text-muted-foreground sm:px-6 lg:px-8'>
                    Framerank lists third-party products. Names and trademarks belong to their owners.
                </p>
            </div>
        </footer>
    )
}
